import { DateTime } from 'luxon';
import React, { createRef, useEffect, useState } from 'react';
import Wrench from '@mui/icons-material/Build';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import { reactFormatter } from 'react-tabulator';
import validator from 'validator';
import Loader from '../../common-components/loader';
import CustomAlert, { CustomAlertType } from '../../Components/CustomAlert';
import TableView from '../../Components/tableView';
import constants from '../../constants';
import ChangeDeviceMailRequest from '../../Model/changeDeviceMailRequest';
import './sensors.scss';
import TableSensorData from '../../Types/TableSensorData';
import CheckDataSensorsModal from '../../Components/Sensors/CheckDataSensorsModal';
import ChangeMailModal from '../../Components/Sensors/ChangeMailModal';
import CheckCurrentSensorModal from '../../Components/Sensors/CheckCurrentSensorModal';
import SensorInfoViewModal from '../../Components/Sensors/SensorInfoViewModal';
import { formatSensorLicenses } from '../../utils/formatSensorLicense';
import Actions from '../../Components/Sensors/Actions';
import ViewIcon from '../../Components/Sensors/ViewIcon';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { banDevice, changeMail, checkDataSensor, fixPinSensor, sensorInfo } from '../../api/sensors';
import { deleteDevice, moveNftsAlgorandAccount } from '../../api/sensors';

const Sensors = () => {
  const [loading, setLoading] = useState(false);
  const [fixPinModal, setFixPinModal] = useState<boolean>();
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<TableSensorData>();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showChangeMail, setShowChangeMail] = useState(false);
  const [showCheckData, setShowCheckData] = useState(false);
  const [sensorId, setSensorId] = useState('');
  const [cdSensorId, setCdSensorId] = useState('');
  const [cdData, setCdData] = useState<string>('');
  const [cdDate, setCdDate] = useState<string>('');
  const [newMail, setNewMail] = useState('');
  const [includeLicense, setIncludeLicense] = useState(false);
  const [openLastData, setOpenLastData] = useState(false);
  const [cdWrongData, setCdWrongData] = useState(false);
  const [cdNoTransmissions, setCdNoTransmissions] = useState(false);
  const [currentSensorCheck, setCurrentSensorCheck] = useState<any>();
  const [fixPin, setFixPin] = useState<any>();
  const [errorType, setErrorType] = useState<CustomAlertType>();

  const { t } = useTranslation();

  const row: any = selectedRow;
  let name: string | undefined;
  let location: string | undefined;
  let lat: number | undefined;
  let lng: number | undefined;

  const sensorFriendlyName = (type: string, device_number: number) =>
    `PW:${type}_${device_number.toString().padStart(6, '0')}`;

  useEffect(() => {
    if (row) {
      name = sensorFriendlyName(row.type, row.device_number);
      // setSensorLicenses(
      //   formatSensorLicenses(
      //     (row.license_type || '').slice(3),
      //     row.device_number
      //   )
      // );
      if (row.last_data) {
        const data = JSON.parse(row.last_data);
        location = data.location;
        if (
          location !== undefined &&
          location !== null &&
          location.length > 0
        ) {
          const array = location.split(',');
          if (array.length === 2) {
            lat = Number.parseFloat(array[0]);
            lng = Number.parseFloat(array[1]);
            console.log(lat, lng);
          }
        }
      }
    }
  }, [row]);

  const formatDate = (date?: string) => {
    if (date !== undefined && date !== null) {
      const dateTime = DateTime.fromISO(date);
      return dateTime
        .setLocale('it-IT')
        .toLocaleString(DateTime.DATETIME_SHORT);
    }
    return '-';
  };

  const sensorsTable = createRef<TableView>();

  const formatLastUpd = (cell: any) => {
    /* eslint-disable i18next/no-literal-string */
    cell
      .getElement()
      .classList.remove('bg-info', 'bg-warning', 'bg-danger', 'bg-secondary');
    const data = cell.getData();
    let className = '';
    if (data.timeNull) {
      className = 'bg-secondary';
    } else if (data.time120) {
      className = 'bg-danger';
    } else if (data.time24) {
      className = 'bg-warning';
    } else if (data.time1) {
      className = 'bg-info';
    } else {
      className = 'bg-success';
    }
    /* eslint-enable i18next/no-literal-string */

    cell.getElement().classList.add(className);
    const value = cell.getValue();
    return formatDate(value);
  };

  const formatSensorName = (cell: any) => {
    const data = cell.getData();
    return sensorFriendlyName(data.type, data.device_number);
  };

  const formatSensorLicense = (cell: any) => {
    const data = cell.getData();
    // const type = data.license_type.slice(3);
    return formatSensorLicenses(
      (data.license_type || '').slice(3),
      data.device_number
    );
  };

  const formatNote = (cell: any) => {
    const data = cell.getData();
    const { pin, id } = data;
    let res = '';
    if (
      pin !== undefined &&
      pin !== null &&
      (pin.startsWith('0') || /.*[a-zA-Z]+.*$/.test(pin))
    ) {
      res = ReactDOMServer.renderToString(
        <>
          <IconButton id={id}>
            <Wrench height={20} />
          </IconButton>
          {t('PIN_ERROR')}
        </>
      );
    }
    return res;
  };

  const fixSensorPin = async (sId: any) => {
    setLoading(true);
    try {
      const result = await fixPinSensor(sId);
      setFixPin(result.data);
      if (result.data.success === true) {
        sensorsTable.current?.reloadData();
      }
    } catch (err: any) {
      setErrorType(CustomAlertType.ERROR);
      setShowError(true);
      setErrorMessage(err.response.data.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // const onFixPin = (e: JQuery.ClickEvent) => {
  //   const sId = e.currentTarget.id;
  //   e?.stopPropagation();
  //   fixSensorPin(sId);
  // };

  const tableBuilt = () => null;

  // const tableBuilt = () => {
  // $('.fix-pin-btn').on('click', onFixPin);
  // if (showModal) {
  //   // Find new row or close modal
  //   console.log('stampo sensor table current ', sensorsTable);
  //   const newRow = sensorsTable.current
  //     ?.getData()
  //     ?.find((x) => x.id === selectedRow?.id);
  //   if (newRow !== undefined && newRow !== null) {
  //     // setSelectedRow(newRow);
  //   } else {
  //     setSelectedRow(undefined);
  //     setShowModal(false);
  //   }
  // }
  // };

  const moveNfts = async (rowData: Record<string, unknown>) => {
    const check = window.confirm(t('CONFIRM_MOVE_NFTS'));
    if (check) {
      const algorandAccount: any = rowData.algo_account as string;
      // TODO: Check account != null ...
      setLoading(true);
      try {
        const result: any = await moveNftsAlgorandAccount(algorandAccount);
        if (result?.data.success) {
          sensorsTable.current?.reloadData();
          setErrorType(CustomAlertType.INFO);
          setShowError(true);
          setErrorMessage(t('MOVED_NFT'));
        }
      } catch (err: any) {
        setErrorType(CustomAlertType.ERROR);
        setShowError(true);
        setErrorMessage(err.response.data.errorMessage);
      } finally {
        setLoading(false);
      }
    }
    return true;
  };

  const deleteDeviceOwner = async (sId: string) => {
    const check = window.confirm(t('CONFIRM_DEVICE_ORDER_DELETE'));
    if (check) {
      setLoading(true);
      try {
        const result: any = await deleteDevice(sId);
        if (result?.data.success) {
          sensorsTable.current?.reloadData();
        }
      } catch (err: any) {
        setErrorType(CustomAlertType.ERROR);
        setShowError(true);
        setErrorMessage(err.response.data.errorMessage);
      } finally {
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const changeMailSensor = (sensor_id: string) => {
    setShowModal(false);
    setShowChangeMail(true);
    setSensorId(sensor_id);
  };

  const checkData = async (sensor_id: string) => {
    setLoading(true);
    try {
      const result = await checkDataSensor(sensor_id);
      if (result.data.success === true) {
        setShowCheckData(true);
        setCdSensorId(result.data.data.sensorId);
        setCdNoTransmissions(result.data.data.noTransmissions);
        setCdWrongData(result.data.data.wrongData);
        setCdData(result.data.data.datA);
        setCdDate(result.data.data.date);
      }
    } catch (err: any) {
      setErrorType(CustomAlertType.ERROR);
      setShowError(true);
      setErrorMessage(err.response.data.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const banSensor = async (rowData: Record<string, unknown>) => {
    const deviceId = rowData.sensor_id as string;
    const check = window.confirm(t('CONFIRM_DEVICE_BAN', { deviceId }));
    if (check) {
      setLoading(true);
      try {
        const result = await banDevice(deviceId);
        setFixPin(result.data);
        if (result.data.success === true) {
          sensorsTable.current?.reloadData();
          setErrorType(CustomAlertType.INFO);
          setShowError(true);
          setErrorMessage(t('BANNED'));
        }
      } catch (err: any) {
        setErrorType(CustomAlertType.ERROR);
        setShowError(true);
        setErrorMessage(err.response.data.errorMessage);
      } finally {
        setLoading(false);
      }
    }
  };

  const getSensorInfo = async (sensorName: string) => {
    setLoading(true);
    let result: any;
    try {
      result = await sensorInfo(sensorName);
      setCurrentSensorCheck(result.data?.data);
      console.log(result);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const buttonAction = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const formatIsAutofilled = (cell: any) => {
    const data = cell.getData();
    return data?.is_autofilled ? t('YES') : t('NO');
  };

  /* eslint-disable quote-props */
  const filterSelectOptions = { '1': t('YES'), '0': t('NO'), '': t('ALL') };
  /* eslint-enable i18next/no-literal-string */

  /* eslint-disable object-curly-newline */
  const columns = [
    {
      title: t('SENSOR_ID'),
      field: 'sensor_id',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SENSOR_NAME'),
      field: 'sensor_name',
      headerSort: false,
      formatter: formatSensorName
    },
    {
      title: t('NFT'),
      field: 'NFTassetID',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SENSOR_LICENSE'),
      field: 'sensor_license',
      headerSort: false,
      formatter: formatSensorLicense
    },
    {
      title: t('DEVICE_NUMBER'),
      field: 'device_number',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('TYPE'),
      width: 90,
      field: 'type',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('MAIL'),
      field: 'mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    { title: t('PIN'), field: 'pin', sorter: 'string', headerFilter: 'input' },
    {
      title: t('LAST_UPDATE'),
      field: 'last_update',
      sorter: 'string',
      headerFilter: 'input',
      formatter: formatLastUpd,
      tooltip: true
    },
    // { title: 'Activation date', field: 'activation_date', sorter: 'string', headerFilter: 'input', tooltip: true },
    // { title: 'Last Access', field: 'last_access', sorter: 'string', headerFilter: 'input', tooltip: true },
    {
      title: t('DATA_COLLECTED'),
      field: 'data_collected',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('GEO'),
      width: 90,
      field: 'geo',
      sorter: 'string',
      headerFilter: 'input'
    },
    // { title: 'NFT', field: 'NFTassetID', sorter: 'string', headerFilter: 'input' },
    {
      title: t('ALGORAND_ACCOUNT'),
      field: 'algo_account',
      sorter: 'string',
      headerFilter: 'input',
      tooltip: true
    },
    {
      title: t('ALGORAND_INFRASTRUCTURE_ACCOUNT'),
      field: 'algo_account_infra',
      sorter: 'string',
      headerFilter: 'input',
      tooltip: true
    },
    {
      title: t('CITY'),
      width: 90,
      field: 'city',
      sorter: 'string',
      headerFilter: 'input',
      tooltip: true,
      formatter: reactFormatter(<ViewIcon />)
    },
    {
      title: t('PROVINCE'),
      width: 90,
      field: 'province',
      sorter: 'string',
      headerFilter: 'input',
      tooltip: true,
      formatter: reactFormatter(<ViewIcon />)
    },
    {
      title: t('COUNTRY'),
      width: 90,
      field: 'country',
      sorter: 'string',
      headerFilter: 'input',
      tooltip: true,
      formatter: reactFormatter(<ViewIcon />)
    },
    {
      title: t('AUTOFILLED'),
      field: 'is_autofilled',
      sorter: 'string',
      headerFilter: 'select',
      visible: false,
      // eslint-disable-next-line i18next/no-literal-string
      editor: 'select',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions,
      width: 80,
      formatter: formatIsAutofilled
    },
    {
      title: t('KYC'),
      field: 'tier',
      sorter: 'string',
      width: 100,
      headerFilter: 'input'
    },
    {
      title: t('LICENSE_ACTIVATION_DATE'),
      field: 'licenseActivation',
      sorter: 'string',
      width: 100,
      headerFilter: 'input',
      visible: false
    },
    {
      title: t('LICENSE_EXPIRATION_DATE'),
      field: 'licenseExpiration',
      sorter: 'string',
      width: 100,
      headerFilter: 'input',
      visible: false
    },
    { title: t('NOTE'), width: 60, headerSort: false, formatter: formatNote },
    {
      title: '',
      sortable: false,
      formatter: reactFormatter(
        <Actions
          props={{
            t: t,
            changeMailSensor: changeMailSensor,
            moveNfts: moveNfts,
            deleteDeviceOwner: deleteDeviceOwner,
            banSensor: banSensor,
            checkData: checkData,
            getSensorInfo: getSensorInfo,
            buttonAction: buttonAction
          }}
        />
      ),
      headerSort: false,
      width: 240,
      widthShrink: 0
    }
  ];
  /* eslint-enable object-curly-newline */

  const closeModal = () => {
    setShowModal(false);
    setShowChangeMail(false);
    setShowCheckData(false);
    // setSelectedRow({});
  };

  const closeFixPinModal = () => setFixPinModal(false);

  const handleSubmit = async () => {
    if (validator.isEmail(newMail)) {
      setShowModal(false);
      setLoading(true);
      const submitData: ChangeDeviceMailRequest = {
        mail: newMail,
        includeLicense: includeLicense
      };
      setLoading(false);

      try {
        const result = await changeMail(
          encodeURIComponent(String(sensorId)),
          submitData
        );
        if (result.data.success === true) {
          setShowChangeMail(false);
          setNewMail('');
          sensorsTable.current?.reloadData();
          setShowModal(false);
          setShowError(true);
          setErrorType(CustomAlertType.INFO);
          setErrorMessage(t('SAVED_DATA'));
        }
      } catch (err: any) {
        setShowChangeMail(false);
        setShowModal(false);
        setShowError(true);
        setNewMail('');
        setErrorType(CustomAlertType.ERROR);
        setErrorMessage(err.response.data.errorMessage);
      } finally {
        setLoading(false);
      }
    } else {
      setShowModal(false);
      setShowChangeMail(false);
      setShowError(true);
      setErrorMessage(t('INVALID_MAIL'));
    }
  };

  const onRowSelected = (rowSelected: any) => {
    // eslint-disable-next-line no-underscore-dangle
    console.log('riga selezionata', rowSelected);
    setShowModal(true);
    setSelectedRow(rowSelected._row.data);
  };

  return (
    <>
        <TableView
          t={t}
          ref={sensorsTable}
          api={constants.api.getSensors}
          columns={columns}
          id={'sensors-live-list'}
          tableProps={{
            paginationSizeSelector: [10, 100, true],
            renderComplete: () => tableBuilt()
          }}
          onRowSelected={(rowSelected: any) => onRowSelected(rowSelected)}
        />

        <CheckDataSensorsModal
          showCheckData={showCheckData}
          closeModal={() => closeModal()}
          row={row}
          cdSensorId={cdSensorId}
          cdData={cdData}
          cdWrongData={cdWrongData}
          cdNoTransmissions={cdNoTransmissions}
          cdDate={cdDate}
        />

        <SensorInfoViewModal
          showModal={showModal}
          closeModal={closeModal}
          row={row}
          name={name}
          fixSensorPin={(value: string) => fixSensorPin(value)}
          formatDate={(value: string) => formatDate(value)}
          setOpenLastData={(value: boolean) => setOpenLastData(value)}
          openLastData={openLastData}
          selectedRow={selectedRow}
          lat={lat}
          lng={lng}
        ></SensorInfoViewModal>

        <ChangeMailModal
          showChangeMail={showChangeMail}
          closeModal={() => closeModal()}
          setNewMail={(value: string) => setNewMail(value)}
          setIncludeLicense={(value: boolean) => setIncludeLicense(value)}
          handleSubmit={() => handleSubmit()}
        />

        <CheckCurrentSensorModal
          currentSensorCheck={currentSensorCheck}
          setCurrentSensorCheck={(value: string) => {
            setShowModal(false);
            setCurrentSensorCheck(value);
          }}
        ></CheckCurrentSensorModal>

        <Dialog
          open={!!fixPinModal}
          fullScreen
          onClose={() => closeFixPinModal()}
        >
          <DialogContent>
            {fixPin?.success && (
              <>
                {t('CHANGE_PIN_SUCCESS')} {fixPin?.data?.newPin}
              </>
            )}
            {!fixPin?.success && <>{t('CHANGE_PIN_ERROR')}</>}
          </DialogContent>
        </Dialog>

        <CustomAlert
          type={errorType}
          show={showError}
          message={errorMessage}
          onClose={() => {
            setShowError(false);
            setErrorMessage('');
          }}
        />
        <Loader fullscreen={true} visible={loading} />
    </>
  );
};

export default Sensors;
